import { isValidPhoneNumber } from 'libphonenumber-js';
export var PHONE_PLACEHOLDER = '+1 (___) ___-____';
var usNumberValidator = function (rule, value, callback) {
    if (value === void 0) { value = ''; }
    if (!isValidPhoneNumber(value)) {
        callback('Please enter a valid 10 digit phone number.');
    }
    else {
        callback();
    }
};
export var usOptionalNumberValidator = function (value) {
    if (value === null ||
        value === PHONE_PLACEHOLDER ||
        isValidPhoneNumber(value))
        return Promise.resolve();
    return Promise.reject(new Error('Please enter a valid 10 digit phone number.'));
};
export default usNumberValidator;
